import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { User } from '@app/models/user';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, finalize } from 'rxjs/operators';
import { UserService } from '@app/services/user/user.service';

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.css']
})
export class AutocompleteComponent implements OnInit {
  firstName = new FormControl();
  users: any;
  userLoading = false;
  searchTerm: string;

  constructor(private userservice: UserService) { }

  ngOnInit() {

    this.userservice.getUsers().subscribe(data => {

    this.users = data;
    });

  }

  setSearchTerm(user) {
    this.searchTerm = user;
  }

}
